import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b6e0d5fc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b6e0d5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e0d5fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6e0d5fc')) {
      api.createRecord('b6e0d5fc', component.options)
    } else {
      api.reload('b6e0d5fc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b6e0d5fc&scoped=true&", function () {
      api.rerender('b6e0d5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PWgnDD22HtTH/JS/teamMember.vue"
export default component.exports